import { render, staticRenderFns } from "./kegiatan.vue?vue&type=template&id=fd6c1caa&"
import script from "./kegiatan.vue?vue&type=script&lang=js&"
export * from "./kegiatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QIcon,QBtn,QList,QItem,QItemSection,QSeparator,QPagination,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QIcon,QBtn,QList,QItem,QItemSection,QSeparator,QPagination})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
